import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { emtContentDataModel } from '../dataModels';
import { PAGE_NAMES } from '../../constants';
import RentalDetailedGrid from './RentalDetailedGrid';

const TruckRentalsCards = ({ contentId }) => {
  const { data, loading, error } = useDataModel('emtContent', {
    variables: { contentId, pageName: PAGE_NAMES.RENTALS },
    skip: !contentId,
  });
  const { title, rentalItems } = data?.emtContent?.content?.rentalsInformationv2?.truckRentals || {};
  return <RentalDetailedGrid title={title} rentalItems={rentalItems} loading={loading} error={error} />;
};

TruckRentalsCards.displayName = 'TruckRentalsCards';
TruckRentalsCards.propTypes = { contentId: PropTypes.string.isRequired };
TruckRentalsCards.dataModel = emtContentDataModel;

export default TruckRentalsCards;